import { render, staticRenderFns } from "./LaborProtectionChecklistCard.vue?vue&type=template&id=4da8fa4f&"
import script from "./LaborProtectionChecklistCard.vue?vue&type=script&lang=ts&"
export * from "./LaborProtectionChecklistCard.vue?vue&type=script&lang=ts&"
import style0 from "./LaborProtectionChecklistCard.vue?vue&type=style&index=0&id=4da8fa4f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports